// FruitsZakatCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import FruitsZakatTable from "./FruitsZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Fruits_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Zakat Buah-buahan - Kalkulator Nisab Zakat Buah-buahan";
const DESCRIPTION =
  "Kalkulator Zakat Buah-buahan adalah alat yang digunakan untuk menghitung jumlah zakat buah-buahan, kurma, dan tanaman yang wajib dikeluarkan sesuai dengan ketentuan syariah dalam Islam. Kalkulator ini digunakan untuk menghitung jumlah uang yang harus dibayarkan sebagai zakat atas hasil panen buah-buahan.";
const KEYWORDS =
  "kalkulator zakat buah-buahan, kalkulator zakat kurma, zakat buah-buahan, cara menghitung zakat buah-buahan, jumlah zakat buah-buahan, aturan zakat buah-buahan, menghitung zakat buah dan sayuran, zakat buah dan sayuran, zakat buah-buahan dalam Islam, cara menghitung zakat buah-buahan, zakat buah-buahan dalam syariah Islam, kalkulator nisab zakat buah-buahan, cara menghitung nisab zakat buah-buahan, kalkulator zakat buah-buahan, nisab zakat buah-buahan dalam Islam, syarat nisab zakat buah-buahan";
const OG_URL = "https://do-calculate.com/calculator/id/fruits-zakat/";
const apiEndpoint = `${SERVER_URL}/${Fruits_Zakat_EndPoint}`;
function FruitsZakatCalculator() {
  const [pricePerKg, setPricePerKgSilver] = useState(0);
  const [weight, setWeight] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [wateringMethod, setWateringMetohd] = useState("");
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleWateringMethodChange = (event) => {
    setWateringMetohd(event.target.value);
  };
  const handlePricePerKgChange = (event) => {
    setPricePerKgSilver(event.target.value);
  };
  const calculateFruitsZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ weight, pricePerKg, wateringMethod }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Hitung Zakat Buah-buahan</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Kalkulator Zakat Buah-buahan adalah alat yang digunakan untuk menghitung jumlah zakat buah-buahan yang wajib dikeluarkan sesuai dengan ketentuan syariah dalam Islam. Kalkulator ini digunakan untuk menghitung jumlah uang yang harus dibayarkan sebagai zakat atas hasil panen buah-buahan, yang mencakup semua jenis buah-buahan. Selain itu, kalkulator zakat kurma juga dapat digunakan untuk menghitung jumlah zakat kurma yang wajib dikeluarkan berdasarkan kuantitas dan nilai finansial kurma yang dipanen. Anda dapat menggunakan alat ini untuk memastikan Anda menunaikan zakat dengan benar dan sesuai dengan ajaran agama.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Zakat Buah-buahan
                </div>
                <hr />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      Total berat buah-buahan dan tanaman{" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kg</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label
                      htmlFor="pricePerKgNumber"
                      className="form-label ms-2"
                    >
                      Harga per kilogram{" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="pricePerKgNumber"
                    value={pricePerKg}
                    onChange={handlePricePerKgChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                </div>
                <br />
                <div>
                  <b>
                    <label htmlFor="method" className="form-label ms-2">
                      Metode pengairan yang digunakan
                    </label>
                  </b>
                  <select
                    id="method"
                    className="form-select"
                    value={wateringMethod}
                    onChange={handleWateringMethodChange}
                  >
                    <option value="">-- Pilih aktivitas --</option>
                    <option value="no-cost">Tanpa biaya</option>
                    <option value="mid-cost">Biaya sedang</option>
                    <option value="full-cost">Biaya penuh</option>
                  </select>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateFruitsZakat}
                       >
                    Hitung
                    </button>              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi kesalahan :</u>
                    </b>{" "}
                    Harap isi semua bidang dengan benar.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        Hasil:{" "}
                      </div>
                    </h4>
                    <hr />
                    <FruitsZakatTable result={result}></FruitsZakatTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Deskripsi Kalkulator Zakat Buah-buahan dan Tanaman{" "}
              </div>
              <div className="info-section-body">
                <u>
                  <b> Kalkulator Zakat Buah-buahan </b>{" "}
                </u>{" "}
                <br/>                Kalkulator menerima tiga parameter:
                <ul>
                  <li>Berat buah-buahan (dalam kilogram)</li>
                  <li>Harga per kilogram buah-buahan</li>
                  <li>Metode pengairan</li>
                </ul>
                Kalkulator menghitung zakat buah-buahan berdasarkan faktor-faktor berikut:
                <ul>
                  <li>Jika metode pengairan tanpa biaya, maka persentase zakat adalah 10%</li>
                  <li>
                    Jika metode pengairan dengan biaya penuh, maka persentase zakat adalah 5%
                  </li>
                  <li>
                    Jika metode pengairan dengan biaya sedang, maka persentase zakat adalah 7.5%
                  </li>
                </ul>
                Kemudian nilai zakat buah-buahan dihitung dalam kilogram dan nilai finansial berdasarkan berat, persentase zakat, dan harga per kilogram buah-buahan. Batas minimum zakat buah-buahan ditetapkan sebesar 635 kilogram.
                <br/>                Kalkulator mengembalikan hasil dalam objek yang berisi informasi berikut:
                <ul>
                  <li>Nilai zakat buah-buahan dalam kilogram.</li>
                  <li>Nilai finansial zakat buah-buahan.</li>
                  <li>Batas minimum zakat buah-buahan.</li>
                </ul>
                <br />
                <hr />
                <b>Sumber: </b>
                <a href="https://www.islamweb.net/id/fatwa/119852/%D8%B2%D9%83%D8%A7%D8%A9%D9%8F-%D8%A7%D9%84%D8%B2%D9%91%D9%8E%D8%B1%D9%92%D8%B9%D9%90-%D8%A7%D9%84%D9%88%D9%8E%D8%A7%D8%AD%D9%90%D8%AF%D9%90-%D8%A5%D8%B0%D8%A7-%D8%A7%D8%AC%D8%AA%D9%8E%D9%85%D9%8E%D8%B9-%D9%81%D9%90%D9%8A%D9%87-%D8%A7%D9%84%D8%B3%D9%91%D9%8E%D9%82%D9%92%D9%8A%D9%8F-%D8%A8%D9%90%D9%85%D9%8E%D8%A7%D8%A1%D9%90-%D8%A7%D9%84%D8%B3%D9%91%D9%8E%D9%85%D9%8E%D8%A7%D8%A1%D9%90-%D9%88%D8%A7%D9%84%D8%A2%D9%84%D9%8E%D8%A9#:~:text=%D9%83%D9%85%D8%A7%20%D8%A3%D9%86%20%D8%A7%D9%84%D8%AC%D9%8F%D9%84%D8%A8%D8%A7%D9%86%20%D8%AA%D8%AC%D8%A8%D9%8F%20%D9%81%D9%8A%D9%87,%D9%88%D9%82%D9%8A%D9%84%D9%8E%20%D8%A8%D9%84%20%D9%8A%D9%8F%D8%B9%D8%AA%D8%A8%D8%B1%D9%8F%20%D8%A8%D8%A7%D9%84%D8%A3%D8%BA%D9%84%D8%A8%20%D9%85%D9%86%D9%87%D9%85%D8%A7">
                  Islam Web
                </a>{" "}
                <br />
                <b>Tanggal revisi terakhir : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default FruitsZakatCalculator;